
/**
 * Module for font related operations.
 */

import OpenTypeJs from 'opentype.js';
import { logger } from "./logger";

const URL_TO_FONT = new Map();
const NOTO_SANS_PATH = '/assets/fonts/Noto_Sans/NotoSans-Regular.ttf';

let notoSansFont;

/**
 * Gets the cached OpentType Font object or load one.
 *
 * @param {String} url  font url
 *
 * @returns Font object
 */

async function getOrLoad(url) {
  let self = this;

  if(URL_TO_FONT.has(url))
    return URL_TO_FONT.get(url);

  try{
    let loadedFont = await OpenTypeJs.load(url);
    URL_TO_FONT.set(url,loadedFont);
    return loadedFont;
  }
  catch(error){
      self.$log.error('Font could not be loaded: ' + error);
  }
}

/**
 * Whether a given Font supports rendering the given text.
 *
 * @param {Object} font  (Opentype Font object) font to test
 * @param {String} text  string to test
 * @returns
 */
function supportsText(font, text) {

  if(font == null)
    return false;

  if(text == null)
    return true;

  for (const char of text) {
      const glyph = font.charToGlyph(char);
      // OpenType.js uses glyph index 0 for missing glyphs ('.notdef')
      if (glyph.index === 0 && char !== '\u0000') {
         return false;
      }
  }
    return true;
}

async function init() {
  // Load Noto Sans.
  notoSansFont = await getOrLoad(NOTO_SANS_PATH);
}

function canBeRenderedWithNotoSans(textToEvaluate){

  if(notoSansFont == null){
    logger.error("Noto Sans font has not been loaded");
    return false;
  }

  return supportsText(notoSansFont,textToEvaluate);
}

export default {
  getOrLoad,
  supportsText,
  canBeRenderedWithNotoSans,
  init
}